import { useMemo } from 'react';
import { useGet } from '../../../../api';
import { ACCESS_ANALYSIS_BASE_URL } from '../consts';
import { DaysRange } from '../../types/DaysRange';

export type PeriodMetrics = {
    days_range: DaysRange;
    total: number;
};
export type SnapshotItem = {
    total: number;
};

export type HostSnapshotItem = SnapshotItem & {
    total_mfa_enforcements?: number;
};

export type PeriodSnapshotItem = SnapshotItem & { period_metrics: Array<PeriodMetrics> };

export type Snapshot = {
    applications: SnapshotItem;
    hosts: HostSnapshotItem;
    inactive_users: SnapshotItem;
    resources: PeriodSnapshotItem;
    users: SnapshotItem;
};

export type SnapshotDto = {
    data: Snapshot;
};

export const EMPTY_SNAPSHOT: Snapshot = {
    applications: {
        total: 0
    },
    hosts: {
        total: 0,
        total_mfa_enforcements: 0
    },
    inactive_users: {
        total: 0
    },
    resources: {
        period_metrics: [],
        total: 0
    },
    users: {
        total: 0
    }
};

export const useGetSnapshot = () => {
    const { data, fetchData, loading } = useGet<SnapshotDto>({
        url: `${ACCESS_ANALYSIS_BASE_URL}/snapshot`
    });

    const snapshot = useMemo(() => {
        if (!data) return EMPTY_SNAPSHOT;

        return data.data;
    }, [data]);

    return { refetchSnapshot: fetchData, snapshotLoading: loading, snapshot };
};
